var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13140_32186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.49337 0 0 3.30113 0 7.76C0 10.0923 0.955813 12.1076 2.5125 13.4997C2.64313 13.6166 2.722 13.7805 2.72738 13.9558L2.77094 15.3789C2.78487 15.8328 3.25369 16.1282 3.66906 15.9448L5.25694 15.2437C5.39152 15.1844 5.54246 15.1734 5.68425 15.2124C6.41394 15.4131 7.1905 15.5199 8 15.5199C12.5066 15.5199 16 12.2188 16 7.75994C16 3.30106 12.5066 0 8 0Z",
    fill: "url(#paint0_radial_13140_32186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13140_32186",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.952 1591.44) scale(1743.36 1743.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60975,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93482,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13140_32186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.71f47653a817ee6fd3f39bca06d4f097.svg";
export { ForwardRef as ReactComponent };